
export const EQUIPMENT_TYPES = [
  'INTRAORAL_CAMERA',
  'INTRAORAL_SENSOR',
  'INTRAORAL_SCANNER',
  "PHOSPHOR_PLATE_SYSTEM",
  'CBCT',
  'PANORAMIC',
  'XRAY_GENERATOR_INTRAORAL',
  'AUTOCLAVE',
  'DISHWASHER',
  'COMPRESSOR',
  'REFRIGERATOR',
  'WASHING_MACHINE',
  'ULTRASONIC_CLEANER',
  'ANESTHESIA_APPARATUS',
  'SUCTION_MOTOR',
  'UNIT',
  'DRYER',
  'INCUBATOR',
  'LIGHT_CURING_LAMP',
  'OTHER'
];

export const RADIOLOGY_TYPES = [
  'CBCT',
  'PANORAMIC',
  'XRAY_GENERATOR_INTRAORAL',
];

export const RELATION_TYPES = [
  { value: 'KONSTANS', label: 'Konstans' },
  { value: 'KONTROL', label: 'Kontrol' },
  { value: 'ARTIFAKT', label: 'Artifakt' },
  { value: 'MAINTENANCE', label: 'Maintenance' },
  { value: 'INSPECTION', label: 'Inspection' },
  { value: 'REPAIR', label: 'Repair' },
  { value: 'CALIBRATION', label: 'Calibration' },
  { value: 'OTHER', label: 'Other' }
];